import React from 'react'

export interface RadioInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  inputSize?: 'md' | 'lg'
  isInvalid?: boolean
}

export const RadioInput = ({
  id,
  label,
  value,
  inputSize: size = 'md',
  isInvalid,
  className,
  children,
  ...props
}: React.PropsWithChildren<RadioInputProps>): React.ReactElement => {
  id = id || ['radio', value].join('-')
  return (
    <div
      className={['form-check ms-2', size === 'lg' && 'form-control-lg', className]
        .filter(Boolean)
        .join(' ')}
    >
      <input
        {...props}
        id={id}
        value={value}
        type="radio"
        className={['form-check-input', isInvalid && 'is-invalid'].filter(Boolean).join(' ')}
      />
      <label className="form-check-label ms-2" htmlFor={id}>
        {children || label}
      </label>
    </div>
  )
}
